// extracted by mini-css-extract-plugin
module.exports = {"section":"iSbvR","activities":"_2AJfV","empty-state":"_21lo1","emptyState":"_21lo1"};